// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var RedirectionUrl$ReactHooksTemplate = require("../surveys/redirectionUrl.res.js");
var RedirectionUrlForm$ReactHooksTemplate = require("./RedirectionUrlForm.res.js");

var initialState_selectedRedirectionUrl = RedirectionUrl$ReactHooksTemplate.empty();

var initialState = {
  loading: true,
  redirectionUrls: /* [] */0,
  redirectionUrlChangeModalToggle: false,
  outsideClick: true,
  selectedRedirectionUrl: initialState_selectedRedirectionUrl,
  formAction: "Create"
};

function reducer(state, action) {
  if (typeof action !== "object") {
    if (action === "FetchRedirectionUrlsInProgress") {
      return {
              loading: true,
              redirectionUrls: state.redirectionUrls,
              redirectionUrlChangeModalToggle: state.redirectionUrlChangeModalToggle,
              outsideClick: state.outsideClick,
              selectedRedirectionUrl: state.selectedRedirectionUrl,
              formAction: state.formAction
            };
    } else {
      return {
              loading: state.loading,
              redirectionUrls: state.redirectionUrls,
              redirectionUrlChangeModalToggle: !state.redirectionUrlChangeModalToggle,
              outsideClick: state.outsideClick,
              selectedRedirectionUrl: state.selectedRedirectionUrl,
              formAction: state.formAction
            };
    }
  }
  switch (action.TAG) {
    case "FetchRedirectionUrlsCompleted" :
        return {
                loading: false,
                redirectionUrls: action._0,
                redirectionUrlChangeModalToggle: state.redirectionUrlChangeModalToggle,
                outsideClick: state.outsideClick,
                selectedRedirectionUrl: state.selectedRedirectionUrl,
                formAction: state.formAction
              };
    case "SetOutsideClick" :
        return {
                loading: state.loading,
                redirectionUrls: state.redirectionUrls,
                redirectionUrlChangeModalToggle: state.redirectionUrlChangeModalToggle,
                outsideClick: action._0,
                selectedRedirectionUrl: state.selectedRedirectionUrl,
                formAction: state.formAction
              };
    case "SetRedirectionUrl" :
        return {
                loading: state.loading,
                redirectionUrls: state.redirectionUrls,
                redirectionUrlChangeModalToggle: state.redirectionUrlChangeModalToggle,
                outsideClick: state.outsideClick,
                selectedRedirectionUrl: action._0,
                formAction: state.formAction
              };
    case "SetFormAction" :
        return {
                loading: state.loading,
                redirectionUrls: state.redirectionUrls,
                redirectionUrlChangeModalToggle: state.redirectionUrlChangeModalToggle,
                outsideClick: state.outsideClick,
                selectedRedirectionUrl: state.selectedRedirectionUrl,
                formAction: action._0
              };
    
  }
}

function totalRecord(x) {
  if (x !== undefined) {
    return x;
  } else {
    return "1";
  }
}

function perPage(x) {
  if (x !== undefined) {
    return x;
  } else {
    return "1";
  }
}

function RedirectionUrls(props) {
  var match = React.useReducer(reducer, initialState);
  var dispatch = match[1];
  var state = match[0];
  var onFormSubmit = function (redirectionUrl) {
    var redirectionUrlId = RedirectionUrl$ReactHooksTemplate.id(redirectionUrl);
    var params = {};
    params["redirection_url"] = RedirectionUrl$ReactHooksTemplate.encode(redirectionUrl);
    var match = state.formAction;
    var formSubmitUrl;
    formSubmitUrl = match === "Create" ? Http$ReactHooksTemplate.fetchPostJSON("/api/v1/redirection_urls", params) : Http$ReactHooksTemplate.fetchPostJSON("/api/v1/redirection_urls/" + String(Belt_Option.getExn(redirectionUrlId)) + "/update", params);
    Js_promise.then_((function (response) {
            var status = Json_decode.field("status", (function (param) {
                    return Json_decode.withDefault("failed", Json_decode.string, param);
                  }), response);
            if (status === "success") {
              window.location.href = "/general_settings#redirection_urls";
              window.location.reload();
            }
            return Promise.resolve();
          }), formSubmitUrl);
  };
  React.useEffect((function (param) {
          Curry._1(dispatch, "FetchRedirectionUrlsInProgress");
          Js_promise.then_((function (param) {
                  return Promise.resolve(Js_promise.then_((function (json) {
                                    return Js_promise.then_((function (redirection_urls) {
                                                  return Promise.resolve(Curry._1(dispatch, {
                                                                  TAG: "FetchRedirectionUrlsCompleted",
                                                                  _0: redirection_urls
                                                                }));
                                                }), Promise.resolve(Json_decode.field("redirection_urls", (function (param) {
                                                          return Json_decode.list(RedirectionUrl$ReactHooksTemplate.decode, param);
                                                        }), json)));
                                  }), param[1]));
                }), Http$ReactHooksTemplate.fetchGetJSONWithHeader("/api/v1/redirection_urls"));
        }), []);
  var tmp;
  if (state.loading) {
    tmp = JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    className: "w-6 h-6 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"
                                  }),
                              JsxRuntime.jsx("span", {
                                    children: "Loading Redirection URLs...",
                                    className: "text-gray-600"
                                  })
                            ],
                            className: "flex items-center space-x-3"
                          }),
                      className: "flex items-center justify-center py-20"
                    }),
                className: "bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden hover:shadow-xl transition-shadow duration-300"
              }),
          className: "max-w-7xl mx-auto px-6 sm:px-8 py-8"
        });
  } else {
    var tmp$1;
    if (state.redirectionUrlChangeModalToggle) {
      var match$1 = state.formAction;
      var tmp$2;
      tmp$2 = match$1 === "Create" ? "Create New Redirection URL" : "Update Redirection URL";
      tmp$1 = JsxRuntime.jsx("div", {
            children: JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("div", {
                          className: "fixed inset-0 transition-opacity",
                          onClick: (function (param) {
                              Curry._1(dispatch, "ToggleRedirectionUrlModal");
                            })
                        }),
                    JsxRuntime.jsx("span", {
                          className: "hidden sm:inline-block sm:align-middle sm:h-screen"
                        }),
                    JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsx("span", {
                                                        children: "🔗",
                                                        className: "text-lg"
                                                      }),
                                                  JsxRuntime.jsx("h3", {
                                                        children: tmp$2,
                                                        className: "text-lg font-bold text-gray-900"
                                                      })
                                                ],
                                                className: "flex items-center space-x-2"
                                              }),
                                          JsxRuntime.jsx("button", {
                                                children: JsxRuntime.jsx("img", {
                                                      className: "h-4 w-4",
                                                      src: Image$ReactHooksTemplate.closeIcon
                                                    }),
                                                className: "text-gray-400 hover:text-gray-600 transition-colors duration-200",
                                                onClick: (function (param) {
                                                    Curry._1(dispatch, "ToggleRedirectionUrlModal");
                                                  })
                                              })
                                        ],
                                        className: "flex items-center justify-between"
                                      }),
                                  className: "bg-gradient-to-r from-blue-50 via-indigo-50 to-purple-50 px-6 py-4 border-b border-gray-200"
                                }),
                            JsxRuntime.jsx(RedirectionUrlForm$ReactHooksTemplate.make, {
                                  toggleModal: (function (param) {
                                      Curry._1(dispatch, "ToggleRedirectionUrlModal");
                                    }),
                                  selectedRedirectionUrl: state.selectedRedirectionUrl,
                                  onFormSubmit: onFormSubmit
                                })
                          ],
                          className: "inline-block align-bottom bg-white rounded-2xl shadow-2xl border border-gray-100 transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full overflow-hidden"
                        })
                  ],
                  className: "flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0"
                }),
            className: "fixed inset-0 z-50 overflow-y-auto",
            style: {
              backgroundColor: "rgba(0, 0, 0, 0.6)"
            }
          });
    } else {
      tmp$1 = null;
    }
    tmp = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx("span", {
                                                  children: "🔗",
                                                  className: "text-xl"
                                                }),
                                            className: "flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br from-blue-100 to-indigo-100 shadow-sm"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("h1", {
                                                    children: "Redirection URLs",
                                                    className: "text-2xl font-bold text-gray-900"
                                                  }),
                                              JsxRuntime.jsx("p", {
                                                    children: "Manage redirection URLs for your surveys and campaigns",
                                                    className: "text-sm text-gray-600 mt-1"
                                                  })
                                            ]
                                          })
                                    ],
                                    className: "flex items-center space-x-3"
                                  }),
                              className: "flex items-center justify-between"
                            }),
                        className: "bg-gradient-to-r from-blue-50 via-indigo-50 to-purple-50 px-6 py-6 border-b border-gray-200"
                      }),
                  className: "bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden mb-6 hover:shadow-xl transition-shadow duration-300"
                }),
            JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx("span", {
                                                  children: "📋",
                                                  className: "text-lg"
                                                }),
                                            JsxRuntime.jsx("h2", {
                                                  children: "URL List",
                                                  className: "text-lg font-bold text-gray-900"
                                                }),
                                            JsxRuntime.jsx("span", {
                                                  children: String(List.length(state.redirectionUrls)) + " URLs",
                                                  className: "inline-flex items-center px-2 py-1 text-xs font-medium text-blue-700 bg-blue-100 rounded-full"
                                                })
                                          ],
                                          className: "flex items-center space-x-2"
                                        }),
                                    JsxRuntime.jsxs("button", {
                                          children: [
                                            JsxRuntime.jsx("span", {
                                                  children: "+",
                                                  className: "mr-2"
                                                }),
                                            "Create New URL"
                                          ],
                                          className: "inline-flex items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200",
                                          onClick: (function (param) {
                                              Curry._1(dispatch, {
                                                    TAG: "SetFormAction",
                                                    _0: "Create"
                                                  });
                                              Curry._1(dispatch, {
                                                    TAG: "SetRedirectionUrl",
                                                    _0: RedirectionUrl$ReactHooksTemplate.empty()
                                                  });
                                              Curry._1(dispatch, "ToggleRedirectionUrlModal");
                                            })
                                        })
                                  ],
                                  className: "flex items-center justify-between"
                                }),
                            JsxRuntime.jsx("p", {
                                  children: "Configure redirection URLs for post-survey actions",
                                  className: "text-sm text-gray-600 mt-1"
                                })
                          ],
                          className: "bg-gradient-to-r from-purple-50 to-pink-50 px-6 py-4 border-b border-gray-200"
                        }),
                    JsxRuntime.jsx("div", {
                          children: List.length(state.redirectionUrls) > 0 ? JsxRuntime.jsxs("table", {
                                  children: [
                                    JsxRuntime.jsx("thead", {
                                          children: JsxRuntime.jsxs("tr", {
                                                children: [
                                                  JsxRuntime.jsx("th", {
                                                        children: "Name",
                                                        className: "text-left py-3 px-4 font-medium text-gray-700"
                                                      }),
                                                  JsxRuntime.jsx("th", {
                                                        children: "URL",
                                                        className: "text-left py-3 px-4 font-medium text-gray-700"
                                                      }),
                                                  JsxRuntime.jsx("th", {
                                                        children: "Actions",
                                                        className: "text-left py-3 px-4 font-medium text-gray-700"
                                                      })
                                                ]
                                              }),
                                          className: "bg-gray-50 border-b border-gray-200"
                                        }),
                                    JsxRuntime.jsx("tbody", {
                                          children: $$Array.of_list(List.map((function (redirectionUrl) {
                                                      return JsxRuntime.jsxs("tr", {
                                                                  children: [
                                                                    JsxRuntime.jsx("td", {
                                                                          children: JsxRuntime.jsx("div", {
                                                                                children: JsxRuntime.jsx("span", {
                                                                                      children: RedirectionUrl$ReactHooksTemplate.name(redirectionUrl),
                                                                                      className: "text-sm font-medium text-gray-900"
                                                                                    }),
                                                                                className: "flex items-center space-x-2"
                                                                              }),
                                                                          className: "py-4 px-4"
                                                                        }),
                                                                    JsxRuntime.jsx("td", {
                                                                          children: JsxRuntime.jsx("span", {
                                                                                children: RedirectionUrl$ReactHooksTemplate.url(redirectionUrl),
                                                                                className: "text-sm text-blue-600 hover:text-blue-800 font-mono"
                                                                              }),
                                                                          className: "py-4 px-4"
                                                                        }),
                                                                    JsxRuntime.jsx("td", {
                                                                          children: JsxRuntime.jsx("div", {
                                                                                children: JsxRuntime.jsx("button", {
                                                                                      children: JsxRuntime.jsx("img", {
                                                                                            className: "h-4 w-4",
                                                                                            src: Image$ReactHooksTemplate.edit
                                                                                          }),
                                                                                      className: "p-2 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors duration-200",
                                                                                      title: "Edit URL",
                                                                                      onClick: (function (param) {
                                                                                          Curry._1(dispatch, {
                                                                                                TAG: "SetRedirectionUrl",
                                                                                                _0: redirectionUrl
                                                                                              });
                                                                                          Curry._1(dispatch, {
                                                                                                TAG: "SetFormAction",
                                                                                                _0: "Update"
                                                                                              });
                                                                                          Curry._1(dispatch, "ToggleRedirectionUrlModal");
                                                                                        })
                                                                                    }),
                                                                                className: "flex items-center space-x-2"
                                                                              }),
                                                                          className: "py-4 px-4"
                                                                        })
                                                                  ],
                                                                  className: "hover:bg-gray-50 transition-all duration-200 hover:shadow-sm"
                                                                }, String(Belt_Option.getExn(RedirectionUrl$ReactHooksTemplate.id(redirectionUrl))));
                                                    }), state.redirectionUrls)),
                                          className: "divide-y divide-gray-100"
                                        })
                                  ],
                                  className: "w-full text-sm"
                                }) : JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx("div", {
                                                children: JsxRuntime.jsx("span", {
                                                      children: "🔗",
                                                      className: "text-2xl text-gray-400"
                                                    }),
                                                className: "w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center"
                                              }),
                                          JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsx("h3", {
                                                        children: "No redirection URLs found",
                                                        className: "text-lg font-medium text-gray-900"
                                                      }),
                                                  JsxRuntime.jsx("p", {
                                                        children: "Get started by adding your first redirection URL",
                                                        className: "text-sm text-gray-500 mt-1"
                                                      })
                                                ]
                                              }),
                                          JsxRuntime.jsxs("button", {
                                                children: [
                                                  JsxRuntime.jsx("span", {
                                                        children: "+",
                                                        className: "mr-2"
                                                      }),
                                                  "Add Your First URL"
                                                ],
                                                className: "inline-flex items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200",
                                                onClick: (function (param) {
                                                    Curry._1(dispatch, {
                                                          TAG: "SetFormAction",
                                                          _0: "Create"
                                                        });
                                                    Curry._1(dispatch, {
                                                          TAG: "SetRedirectionUrl",
                                                          _0: RedirectionUrl$ReactHooksTemplate.empty()
                                                        });
                                                    Curry._1(dispatch, "ToggleRedirectionUrlModal");
                                                  })
                                              })
                                        ],
                                        className: "flex flex-col items-center space-y-4"
                                      }),
                                  className: "text-center py-12"
                                }),
                          className: "overflow-x-auto"
                        })
                  ],
                  className: "bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden hover:shadow-xl transition-shadow duration-300"
                }),
            tmp$1
          ],
          className: "max-w-7xl mx-auto px-6 sm:px-8 py-8"
        });
  }
  return JsxRuntime.jsx("div", {
              children: tmp,
              className: "h-full bg-gray-50"
            });
}

var emptyPageInfo = {
  total: "1",
  per_page: "1"
};

var searchPlaceholder = "Search RedirectionUrls";

var make = RedirectionUrls;

exports.initialState = initialState;
exports.reducer = reducer;
exports.totalRecord = totalRecord;
exports.perPage = perPage;
exports.emptyPageInfo = emptyPageInfo;
exports.searchPlaceholder = searchPlaceholder;
exports.make = make;
/* initialState Not a pure module */
